import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { useState } from 'react';
import {
  Create,
  SimpleForm,
  useNotify,
  useRecordContext,
} from 'react-admin';

import FormUnifiedSend, { ScreenType } from '../FormUnifiedSend';

const CustomerUnifiedSendButton = ({ onClose }) => {

  const notify = useNotify();
  const record = useRecordContext();
  const [displayModal, setDisplayModal] = useState(true);

  const onSuccess = () => {
    notify('Notificação criada com sucesso');
    setDisplayModal(false);
    onClose();
  };

  return (
    <>
      <Dialog
        open={displayModal}
        onClose={() => { setDisplayModal(false); onClose(); }}
        aria-label="Enviar notificação"
      >
        <DialogTitle>{'Envio de notificação'}</DialogTitle>
        <DialogContent>
          <Create title="-Enviar notificação" resource={`chains/chainId/unified-send`} mutationOptions={{ onSuccess }}>
            <SimpleForm defaultValues={{ customerIds: [record.id], pushNotification: true }}>
              <FormUnifiedSend screenType={ScreenType.customer} />
            </SimpleForm>
          </Create>
        </DialogContent>
      </Dialog>
    </ >
  )
}

export default CustomerUnifiedSendButton;
